import React from "react";
import {useAppStore} from "../../common/app.store.consumer";
import {AppStore} from "../../stores/app.store";
import {QuestionItem} from "../../common/webapicall";

interface Props {
	appStore?: AppStore;
	questionList: QuestionItem[];
	onSubmit: () => void;
}

@useAppStore()
export default class QuestionnaireAutoFillRandomizePanel extends React.Component<Props> {
	private questionnaireStore = this.props.appStore.questionnaireStore;

	private randomizeAndSubmitQuestionnaire = () => {
		this.questionnaireStore.randomizeAnswers();
		this.props.onSubmit();
	};

	render() {
		return (
			<div className="randomize-results">
				<h3 className="cih-h3">Randomize results</h3>
				<p className="cih-para">Click the button below to fill the answer sheet with random answers.</p>
				<div>
					<button className="cih-btn" onClick={() => this.questionnaireStore.randomizeAnswers()}>
						Randomize
					</button>
					<button className="cih-btn" disabled={this.questionnaireStore.isQuestionnaireSubmitLoading} onClick={this.randomizeAndSubmitQuestionnaire}>
						Randomize and submit
					</button>
				</div>
			</div>
		);
	}
}
